import { render, staticRenderFns } from "./Granim.vue?vue&type=template&id=0c3802e8&scoped=true&"
import script from "./Granim.vue?vue&type=script&lang=js&"
export * from "./Granim.vue?vue&type=script&lang=js&"
import style0 from "./Granim.vue?vue&type=style&index=0&id=0c3802e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3802e8",
  null
  
)

export default component.exports